/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useState, useEffect
} from 'react';
import { useTranslator } from '@jutro/locale';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { FormModalPopover, platformMessages as commonMessages } from 'ml-components-platform-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { convertToSentenceCase } from 'ml-portals-util-js';
import PropTypes from 'prop-types';
import _ from 'lodash';
import appConfig from 'app-config';

import messages from './BusinessDetailsTableActionComponent.messages';
import metadata from './BusinessDetailsTableActionComponent.metadata.json5';
import styles from './BusinessDetailsTableActionComponent.module.scss'

import BusinessDetailsPopupComponent from '../BusinessDetailsPopupComponent/BusinessDetailsPopupComponent';

const ACTION_ADD_BUSINESS_ACTIVITY = 'addBusinessActivity';
function BusinessDetailsTableActionComponent(props) {
    const {
        submissionVM,
        hideAdd,
        onEdit,
        onRemove,
        onCancel,
        updateWizardData,
        syncExposure,
        getUnderlyingPolicies,
        quotePageAddFunction,
        quotePageEditRemoveFunction,
        createUnderlyingPolicy,
        validateBusinessActivities,
        validateULPolicy,
        viewModelService,
        setIsStepActionModalOpen,
        stepActionData,
        setDisableNextButton
    } = props;
    const {
        showProgressDialog
    } = MLModalService();
    
    const {
        clearAlerts,
        clearSuccessAlerts,
        addSuccessAlert,
    } = MLNotificationBlockUtil();
    
    const isGPA = appConfig.portalCode === 'GPA';
    const isQB = appConfig.portalCode === "QB"
    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const { businessActivities } = pupModel.coverables;
    const translator = useTranslator();
    const [isInEditMode, setIsInEditMode] = useState(false);
    const [nextID, updateNextID] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [exposureVM, setExposureVM] = useState();
    const [isEdit, setIsEdit] = useState();
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const isUMB_NP = isPersonalUmbrella && isModernProduct;

    const bizActivityTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('PUPBusinessType_PUE');
    const bizActivityBusinessTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('PUPBusinessClass_PUE');

    const formatBizactivitiestring = (bizactivity) => {
        return _.get(bizactivity, 'name', 'undefined');
    };

    const addAdditionAlert = (added) => {
        clearSuccessAlerts();
        addSuccessAlert({...messages.BusinessActivityAdded, args: { item: formatBizactivitiestring(added) }}, 'addingBizActivityExposure');
    };

    const undoBizActivityRemoval = (bizactivity) => {
        businessActivities.value.push(bizactivity);
        clearAlerts();
        if(validateBusinessActivities) validateBusinessActivities();
        if(validateULPolicy) validateULPolicy();
    };

    const addRemovalAlert = (bizactivity) => {
        clearSuccessAlerts();
        addSuccessAlert({...messages.BusinessActivityRemoved, args: {item: bizactivity.name }}, 'removeBizActivityExposure', () => undoBizActivityRemoval(bizactivity));
    };

    const resetEditingBusinessActivity = () => {
        businessActivities.value.forEach((ba) => {
            ba.isEditing = false;
        });
    };

    const addBizActivity = () => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add BizActivity`);
        const newBizActivity = {
            tempID: nextID + 1,
            toSync: false,
            isModernProduct: submissionVM.value.isModernProduct_Ext
        };
        updateNextID(nextID + 1);
        const bizActivityVM = viewModelService.create(newBizActivity, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PUPBusinessActivityDTOML');
        resetEditingBusinessActivity();
        bizActivityVM.value.isEditing = true;
        businessActivities.value.push(bizActivityVM.value);
        setIsInEditMode(false);
        return bizActivityVM;
    };


    const editBizActivity = (index) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit BizActivity`);
        const bizActivityVM = businessActivities.children[index.index];

        resetEditingBusinessActivity();
        bizActivityVM.value.isEditing = true;
        bizActivityVM.value.isModernProduct = submissionVM.value.isModernProduct_Ext;
        setIsInEditMode(true);
        // editPolicy = _.clone(bizactivities.findFirstElement(bizActivityVM).value);
        return bizActivityVM;
    };

    const saveBizActivityEdit = (bizActivity) => {
        let currentIndex = -1;
        if (bizActivity.publicID.value) {
            currentIndex = businessActivities.children.findIndex((ba) => { return ba.publicID.value === bizActivity.publicID.value; });
        } else {
            currentIndex = businessActivities.children.findIndex((ba) => { return ba.tempID.value === bizActivity.tempID.value; });
        }
        if (currentIndex !== -1) {
            businessActivities.value[currentIndex] = bizActivity.value;
        }
    };

    const createExposureModal = (_exposureVM, _isEdit) => {
        setIsModalOpen(true);
        setExposureVM(_exposureVM);
        setIsEdit(_isEdit);
    }

    const getModal = () => {
        const bizActivityModelTitle = isEdit ? translator(messages.EditBusinessActivityPopupTitle) : translator(messages.AddBusinessActivityPopupTitle);
        const bizActivityModelSubtitle = translator(messages.BusinessActivityPopupSubtitle);

        const onRejectAddition = () => {
            const index = businessActivities.value.indexOf(exposureVM.value);
            if (index !== -1) {
                if (!isEdit) {
                    businessActivities.value.splice(index, 1);
                }
                updateWizardData(submissionVM);
                if(validateBusinessActivities) validateBusinessActivities();
                if(validateULPolicy) validateULPolicy();
                setIsModalOpen(false);
            }
        };

        const onSaveBizActivity = () => {
            const bizActivity = exposureVM;
            if (bizActivity.ulPolicyFixID.value === 'new') {
                bizActivity.ulPolicyFixID = undefined;
            }
            if(validateBusinessActivities) validateBusinessActivities();
            if (bizActivity.aspects.valid && bizActivity.aspects.subtreeValid) {
                if (isInEditMode) {
                    saveBizActivityEdit(bizActivity);
                } else {
                    addAdditionAlert(bizActivity.value);
                }
                updateWizardData(submissionVM);
                
                if(validateULPolicy) validateULPolicy();
                return true;
            }
            return false;
        };

        const componentProps = {
            title: bizActivityModelTitle,
            subtitle: bizActivityModelSubtitle,
            onSaveAction: (shouldClose) => shouldClose,
            CustomComponent: BusinessDetailsPopupComponent,
            overrideProps: {
                submissionVM,
                pupModel,
                businessActivityVM: exposureVM,
                syncExposure,
                getUnderlyingPolicies,
                showProgressDialog,
                createUnderlyingPolicy,
                onSaveBizActivity,
                onModelChange: () => {
                    updateWizardData(submissionVM)
                }
            },
            isOpen: isModalOpen,
            onReject: onRejectAddition,
            onResolve: () => { setIsModalOpen(false)}
        };

        return (<FormModalPopover {...componentProps} />)
    };


    const onAddBizActivity = () => {
        const bizactivityVM = addBizActivity();
        createExposureModal(bizactivityVM, false);
        setDisableNextButton(false);
    };

    const onEditBizActivity = (index) => {
        const bizactivityVM = editBizActivity(index);
        createExposureModal(bizactivityVM, true);
        setDisableNextButton(false);
    };

    const onRemoveBizActivity = (index) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Excluded BizActivity`);
        const bizactivityToRemove = businessActivities.value[index.index];
        businessActivities.value.splice(index.index, 1);
        addRemovalAlert(bizactivityToRemove);
        updateWizardData(submissionVM);
        if(validateBusinessActivities) validateBusinessActivities();
        if(validateULPolicy) validateULPolicy();
        setDisableNextButton(false);
    };

    // Redirect Function
    const handleStepAction = (redirectAction) => {
        if (!_.isEmpty(redirectAction)) {
            if (redirectAction.action === ACTION_ADD_BUSINESS_ACTIVITY) {
                onAddBizActivity();
                setIsStepActionModalOpen(true);
            }
        }
    };

    useEffect(() => {
        if (!_.isEmpty(stepActionData)) {
            handleStepAction(stepActionData);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // End Redirect Functions

    const editBizActivityClicked = (index) => {
        if (quotePageEditRemoveFunction) return quotePageEditRemoveFunction();
        if (onEdit) return onEdit(businessActivities.children[index.index].value, onCancel);
        setDisableNextButton(false);
        return onEditBizActivity(index);
    };

    const removeBizActivityClicked = (index) => {
        if (quotePageEditRemoveFunction) return quotePageEditRemoveFunction();
        if (onRemove) return onRemove(businessActivities.children[index.index].value, onCancel);
        setDisableNextButton(false);
        return onRemoveBizActivity(index);
    };

    const generateBizActivityOverrides = () => {
        if (businessActivities.value) {
            const getTypeKeyDescription = (typeKeyName) => {
                return translator({
                    id: typeKeyName,
                    defaultMessage: typeKeyName
                });
            };

            const overrides = businessActivities.value.map((bizActivity, index) => {
                return {
                    [`nameOfBusinessCell${index}`]: {
                        content: bizActivity.name
                    },
                    [`nameOfBusinessCellStatus${index}`]: {
                        visible: bizActivity.error === true
                    },
                    [`coverageTypeCell${index}`]: {
                        content: !isUMB_NP ? bizActivity.businessType !== undefined ? getTypeKeyDescription(bizActivityTypeList.getCode(bizActivity.businessType).name) : ''  : bizActivity.businessClass !== undefined ? getTypeKeyDescription(bizActivityBusinessTypeList.getCode(bizActivity.businessClass).name)  : ''
                    },
                    [`editActionCell${index}`]: {
                        content: 'Edit',
                        'aria-labelledby': `nameOfBusinessCellContent${index} coverageCellContent${index}`
                    },
                    [`removeActionCell${index}`]: {
                        content: 'Remove',
                        'aria-labelledby': `nameOfBusinessCellContent${index} coverageCellContent${index}`
                    },
                };
            });
            return Object.assign({}, ...overrides);
        }
        return {};
    };

    const overrideProps = {
        bizActivityHeader: {
            content: translator(messages.BusinessActivityHeader)
        },
        headerRow: {
            visible: businessActivities.length > 0
        },
        bizActivityParagraph: {
            visible: businessActivities.length <= 0,
            content: translator(messages.BusinessActivityParagraph)
        },
        bizActivitiesIterable: {
            visible: businessActivities.length > 0,
            data: businessActivities.value
        },
        mlTableActionsDefaultButton: {
            visible: !hideAdd,
            className: isQB ? 'display-inline-block margin-top-20 secondaryButton' : 'display-inline-block margin-top-20',
            type: isGPA ? 'outlined' : 'filled',
            content: isQB ? convertToSentenceCase(translator(messages.AddBusinessActivity)) : translator(messages.AddBusinessActivity),
            onClick: onAddBizActivity
        },
        ...generateBizActivityOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onEditBizActivity: editBizActivityClicked,
            onAddBizActivity: quotePageAddFunction || onAddBizActivity,
            onRemoveBizActivity: removeBizActivityClicked,
            getUnderlyingPolicies
        }
    };

    return (
        <>
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                onModelChange={updateWizardData}
            />
            {isModalOpen && getModal()}
        </>
    );
}

BusinessDetailsTableActionComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    hideAdd: PropTypes.bool,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    onCancel: PropTypes.func,
    updateWizardData: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    getUnderlyingPolicies: PropTypes.func.isRequired,
    syncExposure: PropTypes.func.isRequired,
    quotePageAddFunction: PropTypes.func,
    quotePageEditRemoveFunction: PropTypes.func
};

BusinessDetailsTableActionComponent.defaultProps = {
    hideAdd: false
};

export default BusinessDetailsTableActionComponent;
